import { render, staticRenderFns } from "./AboutWidget.vue?vue&type=template&id=4d254351&"
import script from "./AboutWidget.vue?vue&type=script&lang=js&"
export * from "./AboutWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports